import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App.tsx'
import './index.css'
import { ThemeProvider } from '@/contexts/ThemeContext'
import { LanguageProvider } from '@/contexts/LanguageContext'
import { AuthProvider } from '@/contexts/AuthContext'
import { SectorProvider } from '@/contexts/SectorContext'
import { SupabaseProvider } from '@/lib/supabase'
import { ModeProvider } from '@/contexts/ModeContext'

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      gcTime: 1000 * 60 * 30, // 30 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

// Register Service Worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(registration => {
        console.log('ServiceWorker registration successful:', registration.scope)
      })
      .catch(error => {
        console.error('ServiceWorker registration failed:', error)
      })
  })
}

const root = createRoot(document.getElementById('root')!)

// Wrap the app with necessary providers in the correct order
root.render(
  <BrowserRouter>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <LanguageProvider>
          <SupabaseProvider>
            <AuthProvider>
              <SectorProvider>
                <ModeProvider>
                  <App />
                </ModeProvider>
              </SectorProvider>
            </AuthProvider>
          </SupabaseProvider>
        </LanguageProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </BrowserRouter>
)
